import { render, staticRenderFns } from "./Uploadingcertificate.vue?vue&type=template&id=162a05d8&scoped=true"
import script from "./Uploadingcertificate.vue?vue&type=script&lang=js"
export * from "./Uploadingcertificate.vue?vue&type=script&lang=js"
import style0 from "./Uploadingcertificate.vue?vue&type=style&index=0&id=162a05d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162a05d8",
  null
  
)

export default component.exports